export default __webpack_public_path__ + "static/media/BADGES_FINAL_PSPO-I_600.687f48ac.png";